import map from 'mn-utils/map';

const STATUSES_IDS_LIST = [
  'ready_for_withdraw',
  'requested_by_merchant',
  'approved_by_buyer',
  'refund_done',
  'failed',
  'cancelled'
];

const STATUSES_NAMES = {
  ready_for_withdraw: 'Ready for Withdrawal',
  requested_by_merchant: 'Requested by Merchant',
  approved_by_buyer: 'Approved by Buyer',
  refund_done: 'Refund Completed',
  failed: 'Refund Failed',
  cancelled: 'Refund Cancelled',
};

module.exports = {
  statusesFilter: {
    name: 'status',
    placeholder: 'Status',
    className: 'wAuto (wmin105|wFitContent)>.MuiSelect-root',
    list: map(STATUSES_IDS_LIST, (id) => ({
      id,
      name: STATUSES_NAMES[id]
    }))
  },
  statusesNames: STATUSES_NAMES
}
